var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInternetSpeed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5913C21 19.1256 20.7964 18.7531 20.5588 18.2641L13.5104 3.31556C13.0352 2.31434 12.594 2 11.9943 2C11.3947 2 10.9648 2.31434 10.4896 3.31556L3.42992 18.2641C3.20365 18.7647 3 19.1373 3 19.6029C3 20.4645 3.63356 21 4.61785 21L19.3708 20.9884C20.3551 20.9884 21 20.4528 21 19.5913Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInternetSpeed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-internet-speed.ffe48a17b7879a81fbea62963baf0e3d.svg";